/**
 * Glance stats for the account picker.
 *
 * Unread still comes from world_inbox (received mail). Sent counts come from
 * world_sent — the picker used to query the inbox for "Mails · 7d", which is
 * why that number stayed at 0 even when the account had been sending.
 *
 * world_sent.timestamp is written two ways:
 *   - Firestore Timestamp (serverTimestamp) — current senders
 *   - epoch-ms number — older / migrated docs
 * A single range query can only match one type, so both must be counted and
 * added. A field cannot be both types, so there is no overlap.
 */

export const UNREAD_WINDOW_MS = 7 * 24 * 60 * 60 * 1000;
export const SENT_WINDOW_7D_MS = 7 * 24 * 60 * 60 * 1000;
export const SENT_WINDOW_24H_MS = 24 * 60 * 60 * 1000;

export function glanceWindows(now = Date.now()) {
  return {
    unreadSince: now - UNREAD_WINDOW_MS,
    sentSince7d: now - SENT_WINDOW_7D_MS,
    sentSince24h: now - SENT_WINDOW_24H_MS,
  };
}

export function sumTypedCounts(timestampCount, numberCount) {
  const a = Number(timestampCount) || 0;
  const b = Number(numberCount) || 0;
  return Math.max(0, a + b);
}

export function formatGlanceCount(n) {
  if (typeof n !== 'number' || !Number.isFinite(n)) return '—';
  if (n > 999) return '999+';
  return String(n);
}
